<body>
    <div class="header">
        <div class="container">
            <div class="row flex-nowrap justify-content-between">
                <nav class="navbar navbar-expand-lg navbar-light">
                    <div class="row">
                        <div class="col-lg-2 col-sm-2">
                            <img class="header-logo" src="assets/images/logo_56.png">
                        </div>
                        <div class="col-lg-10 col-sm-10">
                            <a class="navbar-brand header-text" href="#">Smart Century Technologies</a>
                        </div>
                    </div>
                    <div>
                        <button class="navbar-toggler float-xs-right" type="button" data-toggle="collapse" data-target="#navbarTogglerDemo02" aria-controls="navbarTogglerDemo02" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-icon"></span>
                        </button>
                        <div class="collapse navbar-collapse" id="navbarTogglerDemo02">
                            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
                                <li class="nav-item">
                                    <a data-toggle="collapse" data-target=".navbar-collapse.show" class="nav-link" routerLink="/" routerLinkActive #rla1="routerLinkActive" [routerLinkActiveOptions]="{exact: true}" [ngStyle]="{'text-decoration': (rla1.isActive ? 'underline' : 'none')}">Home</a>
                                </li>
                                <li class="nav-item">
                                    <a data-toggle="collapse" data-target=".navbar-collapse.show" class="nav-link" routerLink="/Mission" routerLinkActive #rla2="routerLinkActive" [routerLinkActiveOptions]="{exact: true}" [ngStyle]="{'text-decoration': (rla2.isActive ? 'underline' : 'none')}">Mission</a>
                                </li>
                                <li class="nav-item">
                                    <a data-toggle="collapse" data-target=".navbar-collapse.show" class="nav-link" routerLink="/Services" routerLinkActive #rla3="routerLinkActive" [routerLinkActiveOptions]="{exact: true}" [ngStyle]="{'text-decoration': (rla3.isActive ? 'underline' : 'none')}">Services</a>
                                </li>
                                <li class="nav-item">
                                    <a data-toggle="collapse" data-target=".navbar-collapse.show" class="nav-link" routerLink="/Partners" routerLinkActive #rla4="routerLinkActive" [routerLinkActiveOptions]="{exact: true}" [ngStyle]="{'text-decoration': (rla4.isActive ? 'underline' : 'none')}">Partners</a>
                                </li>
                                <li class="nav-item">
                                    <a data-toggle="collapse" data-target=".navbar-collapse.show" class="nav-link" routerLink="/Contacts" routerLinkActive #rla5="routerLinkActive" [routerLinkActiveOptions]="{exact: true}" [ngStyle]="{'text-decoration': (rla5.isActive ? 'underline' : 'none')}">Contacts</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
                </div>
            </div>
        </div>
    
    <div class="content" data-toggle="collapse" data-target=".navbar-collapse.show">
        <div class="bg-image">
            <img class="img-fluid" src="assets/images/bridge_min.jpg">
            <div class='bg-image-div'>
                <div class='bg-image-div-text'>
                    A bridge to the future.
                </div>
            </div>
        </div>
        <div class="content-text">
            <router-outlet></router-outlet>
        </div>
    </div>
    <div class="footer">
        <div class="footer-content">
            <div class="row">
                <div class="col-lg-6">
                    <div class="footer-content-column-title">
                        Services
                    </div>
                    <div class="footer-content-menu">
                        <div>&#9675; Enterprise Software Development</div>
                        <div>&#9675; Mobile Development</div>
                        <div>&#9675; UX/UI Design</div>
                        <div>&#9675; IT Consulting</div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="footer-content-column-title">
                        Contacts
                    </div>
                    <div class="footer-content-menu">
                        <div>
                            Email: 
                        </div>
                        <div class="link-bar">
                            <a href="mailto:office@smartcenturytechnologies.com">office@smartcenturytechnologies.com</a>
                        </div>
                        <div>
                            Phone: 
                        </div>
                        <div class="link-bar">
                        <a href="tel:+359889668878">+(359) 889 66 88 78</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-subline">
        <div class="footer-subline-content">
            <!--
            <div class="row">
                <div class="col-md-3 ml-auto">Privacy Policy</div>
                <div class="col-md-3 ml-auto">Terms and Conditions</div>
                <div class="col-md-4 ml-auto">Smart Century Technologies Ltd. 2021</div>
            </div>
            -->
            <div class="row">
                <div class="mx-auto">Smart Century Technologies Ltd. {{currentYear}}</div>
            </div>
        </div>
    </div>
</body>